export default {
  selectedUserInterest: state => state.selectedUserInterest
}
